import styled, { css } from 'styled-components'
import { NavLink } from 'react-router-dom'
import Icon from '@mdi/react'
import theme from 'theme_'

export const StyledAccountMenu = styled.nav`
  display: flex;
  flex-direction: column;
  color: ${theme.colors.dolphinGrey};
  animation: ${theme.animations.fadeIn} 0.2s ease;

  @media ${theme.devices.desktop} {
    position: absolute;
    z-index: 2;
    top: calc(100% + ${theme.spacing.xs});
    right: 0;
    width: 300px;
    border-radius: ${theme.spacing.xs};
    background-color: ${theme.colors.white};
    backdrop-filter: ${theme.overlay.SBlur};
    box-shadow: 0 2px 10px ${theme.overlay.newMenuHover};
  }
`
export const accountMenuItemCss = css`
  display: flex;
  align-items: center;
  height: 56px;
  width: 100%;
  padding: 0 ${theme.spacing.sm};
  color: ${theme.colors.otterWarmBlack};
  text-decoration: none;
  transition: all 0.2s ease;

  :hover {
    background-color: ${theme.overlay.newMenuHover};
  }

  &.active {
    color: ${theme.colors.horizonOrange};
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }
`
export const StyledAccountMenuLink = styled(NavLink)`
  ${accountMenuItemCss}
`

export const StyledAccountMenuLogout = styled.button`
  display: flex;
  align-items: center;
  text-align: left;
  height: 64px;
  width: 100%;
  padding: 0 ${theme.spacing.sm};
  color: ${theme.colors.otterWarmBlack};
  border: none;
  border-radius: 0 0 ${theme.spacing.xs} ${theme.spacing.xs};
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;

  :hover {
    background-color: ${theme.overlay.newMenuHover};
  }
`

export const StyledAccountMenuIcon = styled(Icon)`
  margin-right: ${theme.spacing.md};
`

export const AccountMenuAvatarWrap = styled.div`
  margin-right: ${theme.spacing.md};
`
